var date = {};
module["exports"] = date;
date.month = require("./month");
date.weekday = require("./weekday");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/date/index.js
 ** module id = 1014
 ** module chunks = 0
 **/